// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroOutlinedSvg from "@ant-design/icons-svg/es/asn/EuroOutlined";
import AntdIcon from '../components/AntdIcon';

var EuroOutlined = function EuroOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroOutlinedSvg
  }));
};

EuroOutlined.displayName = 'EuroOutlined';
export default React.forwardRef(EuroOutlined);